
import React from 'react';
import { Growl } from 'primereact/growl';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Dropdown } from 'primereact/dropdown';
import servicioTrabajador from '../servicios/ServicioTrabajador';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioHttp from '../servicios/ServicioHttp';
import servicioObjetos from '../servicios/ServicioObjetos';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import {DetalleDocumentos}  from './DetalleDocumentos';
import ModalSubirExpediente from './ModalSubirExpediente';
import {DetalleAfil} from './DetalleAfil';

export class Expediente extends React.Component {
    constructor() {
        super();
        this.state = {
            paginacion: { registrosPorPagina: 20 },
            inicio: 0,
            trabajador: {},
            emisores:[],
            emisor:{}


        }
        this.buscarLink = this.buscarLink.bind(this);
        this.buscarLinkAfil = this.buscarLinkAfil.bind(this);
        this.llenar = this.llenar.bind(this);
        this.llenarAfil = this.llenarAfil.bind(this);
    }

    componentDidMount() {
     //  this.obtenerPagina();
     this.obtenerRfcsEmisores();
    }


    obtenerRfcsEmisores = () => {
        servicioHttp.consumirPostHttp('/emisor/obtener_por_cliente.json').then(response =>{
            if(response.data.error){
                return this.growl.show({ severity: 'error', summary: '', detail: response.data.mensaje });
            }else{
                let emisores=[];
                for(let i=0;i<response.data.lista.length;i++){
                    let objeto=response.data.lista[i];
                    console.log(objeto);
                    emisores.push({id:objeto[0],rfc:objeto[1],nombre:objeto[1]+" - "+objeto[2]});
                }
                this.setState({emisores:emisores});
            }            
        }).catch(error =>{

        });
    }
    asignarEmisor= (valor) =>{
        console.log(valor.emisor.id);
        this.setState({emisor:valor.emisor});
    }
    buscarRecibos = () => {
        let { emisor, paginacion } =this.state;
        if(servicioObjetos.esObjetoVacio(emisor)){
            this.growl.show({ life: 3000, severity: 'error', summary: '', detail: "Debe de elegir un emisor para realizar la búsqueda" });
            return;
        }
        paginacion.join={"trNominas":"trNominas",
                        "alias_trNominas.tcEmisor":"elEmisor"};
        paginacion.numeroPagina=0;
        paginacion.restricciones={"alias_elEmisor.rfc":emisor.rfc};
        this.setState({paginacion:paginacion,trabajador:{}});
        this.obtenerPagina();
    }


    cambiaPagina(event) {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerPagina();
    }
    obtenerPagina() {
        let { paginacion } = this.state;
        servicioTrabajador.paginacion(paginacion).then((response) => {
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                if (response.data.error === false)
                this.setState({ paginacion: response.data.objeto });

        }).catch((error) => {
            if (error)
                console.log("error");
            return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });
    }
    buscarLike() {
        let { trabajador, paginacion } = this.state
        servicioTrabajador.buscar_like(trabajador).then((response) => {
            if (response.data.lista.length === 0) {
                this.growl.show({ life: 1000, severity: 'error', summary: '', detail: 'No existe informaci\u00f3n con los valores ingresados, verifica tus datos' });
                paginacion['datos'] = response.data.lista;
                this.setState({ paginacion });
            } else {
                this.growl.show({ life: 1000, severity: 'success', summary: '', detail: "Valores encontrados" });
                paginacion['datos'] = response.data.lista;
                this.setState({ paginacion });
            }
        })
    }
    asignarValores = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
    }
    llenar(objeto) {
console.log(objeto.id);
        return <div className="CfdiPagos">
            <DetalleDocumentos id={objeto.id} app="Mi App React" />
        </div>
    }
    llenarAfil(objeto) {

        return <div className="CfdiPagos">
          <DetalleAfil id={objeto.id} app="Mi App React" />
        </div>
    }
    buscarLink(rowData, column) {

        return <div>

            <Link to={{
                pathname: "/consultareciboquadrum/bienvenido/detalledocumentos",
                state: { id: column.rowData }
            }} onClick={this.llenar.bind(this, column.rowData)}>Buscar Expediente</Link>

        </div>;
    }
    buscarLinkAfil(rowData, column) {

        return <div>

            <Link to={{
                pathname: "/consultareciboquadrum/bienvenido/detalleafil",
                state: { id: column.rowData }
            }} onClick={this.llenar.bind(this, column.rowData)}>Ver Afil</Link>

        </div>;
    }

    render() {
        let { trabajador,paginacion,inicio,emisor,emisores } = this.state;
        return (
            <div className="content-section implementation">
                <Growl ref={(el) => this.growl = el} />
                <div className="card card-w-title">
                    <h1>Expedientes</h1>
                    <div className="p-fluid p-grid">
                    <div className="p-col-12 p-md-2">* Seleciona un emisor</div>
                    <div className="p-col-12 p-md-6"><Dropdown value={emisor} options={emisores} onChange={(e) => {this.asignarEmisor({emisor: e.value})}} placeholder="Selecione un emisor" optionLabel="nombre"/></div>
                    <div className="p-col-12 p-md-2"><Button label="Buscar Recibos" icon="pi-md-search" onClick={this.buscarRecibos} /></div>
                </div>
                    <ModalSubirExpediente></ModalSubirExpediente>
                    <div className="p-col-12 p-md-12">
                        <label htmlFor="fechaInicial">*Buscar empleado</label>
                    </div>
                    <div className="p-col-12 p-md-12">
                        <InputText className="p-inputtext" placeholder="Buscar por nombre de trabajador o por rfc de trabajador" name="trabajador.nombre" value={trabajador.nombre || ''}
                            onChange={this.asignarValores} onKeyUp={this.buscarLike.bind(this)} />
                    </div>
                    <div className="content-section implementation">
                    <DataTable value={paginacion.datos} editable={true} selectionMode="single" scrollable={true} resizableColumns={true} responsive={true}>
                            <Column field="rfc" header="Rfc" />
                            <Column field="nombre" header="Nombre" />
                            <Column field="curp" header="Curp" />
                            <Column header="Buscar Expediente" body={this.buscarLink} style={{ textAlign: 'center', width: '8em' }}> </Column>
                            <Column header="Ver Afil" body={this.buscarLinkAfil} style={{ textAlign: 'center', width: '8em' }}> </Column>
                        </DataTable>
                        <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                    </div>
                </div>
            </div>

        );
    }
}